import clsx from 'clsx';
import mergeRefs from 'merge-refs';
import { forwardRef, useRef } from 'react';
import { twMerge } from 'tailwind-merge';

import type { IRadioTabProps } from './IRadioTabProps';

const RadioTab = forwardRef<HTMLInputElement, IRadioTabProps>(
  (props, forwardedRef) => {
    const { className, title, checked, ...rest } = props;

    const ref = useRef<HTMLInputElement>(null);

    return (
      <label
        className={clsx({
          'border-mobile-gray-200 items-center cursor-pointer rounded-lg border bg-white px-4 py-3 transition-colors flex w-max min-w-fit text-sm md:text-base':
            true,
          'border-mobile-gray-500': checked,
        })}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            ref?.current?.click?.();
          }
        }}
      >
        {title}
        <input
          className={twMerge(
            'accent-mobile-gray-500 ml-auto h-[1px] w-[1px] opacity-0',
            className
          )}
          type="radio"
          ref={mergeRefs(ref, forwardedRef)}
          {...rest}
        />
      </label>
    );
  }
);

RadioTab.displayName = 'RadioTab';

export default RadioTab;
